export default "__VITE_ASSET__D1pZDdzS__"